import React from 'react';

import { useProgressiveImage } from '~/src/helpers/hooks/useProgressiveImage';

import * as ST from './styled';

export interface IFunctionality {
    id: number | string,
    image: string,
    image_webp: string,
    icon: string,
    title: string,
    text: string,
    alt: string,
}

const FunctionalityItem = ({ item }: { item: IFunctionality }) => {
    const backgroundImg = useProgressiveImage(
        item.image_webp,
        { hasTimeout: false, timeoutDelay: 0 },
        item.image,
    );

    return (
        <ST.FunctionalityItem
            key={item.id}
            role='img'
            backgroundImg={backgroundImg || ''}
            icon={item.icon}
            aria-label={item.alt}
            data-test='functionality-item-image'
        >
            <ST.DescWrap>
                <ST.DescInner>
                    <ST.Title data-test='functionality-item-title'>{item.title}</ST.Title>
                    <ST.Text data-test='functionality-item-text'>{item.text}</ST.Text>
                </ST.DescInner>
            </ST.DescWrap>
        </ST.FunctionalityItem>
    );
};

export default React.memo(FunctionalityItem);
